import React from 'react';
import {Box, Stack} from '@mui/material';
import {Body, Label, designSystemToken} from '@lightricks/react-design-system';
import formatCentsToDollars from '@/utils/formatCentsToDollars';
import translate from '@/utils/translate';
import type {ProposalAnswer} from '@/api/fetchers/proposal';
import styles from '../CreatorSidePanel.module.scss';

type ApplicationTabProps = {
  questions: ProposalAnswer[];
  isNegotiatedTermsVisible?: boolean;
  negotiatedCostInCents?: number | null;
  usageRightsPeriodInMonths?: number | null;
};

function ApplicationTab({
  questions,
  isNegotiatedTermsVisible = false,
  negotiatedCostInCents,
  usageRightsPeriodInMonths,
}: ApplicationTabProps) {
  return (
    <Box className={styles.tabContent}>
      <Stack className={styles.applicationList}>
        {isNegotiatedTermsVisible && (
          <>
            {negotiatedCostInCents != null && (
              <Stack className={styles.applicationItem}>
                <Label
                  size="sm"
                  color={designSystemToken('semantic.fg.secondary')}
                >
                  {translate('Price')}
                </Label>
                <Body size="md">
                  {formatCentsToDollars(negotiatedCostInCents)}
                </Body>
              </Stack>
            )}
            {usageRightsPeriodInMonths && (
              <Stack className={styles.applicationItem}>
                <Label
                  size="sm"
                  color={designSystemToken('semantic.fg.secondary')}
                >
                  {translate('Usage Rights Period')}
                </Label>
                <Body size="md">
                  {translate('month', {count: usageRightsPeriodInMonths})}
                </Body>
              </Stack>
            )}
          </>
        )}
        {questions.map((item) => (
          <Stack key={item.question} className={styles.applicationItem}>
            <Label size="sm" color={designSystemToken('semantic.fg.secondary')}>
              {item.question}
            </Label>
            <Body size="md">{item.answer}</Body>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}

export default ApplicationTab;
